import React from "react";
import "./TradingAccounts.css";
import { Link } from "react-router-dom";
import image from "./light-dotted-arrow.svg";
function TradingAccounts() {
  return (
    <>
      <div className="trading-accounts-section">
        <div className="trading-accounts">
          <div className="trading-accounts-title">
            <h3>Trading accounts for all styles</h3>
            <p>
              Kickstart your trading journey with WLF Finance and explore our
              tailored trading accounts designed to suit your unique style and
              preferences. We don’t just offer an account; it's a complete
              trading experience.
            </p>
          </div>
          <div className="trading-accounts-cards-area">
            <div className="trading-accounts-cards">
              <div className="trading-accounts-card-item">
                <h3>Micro</h3>
                <p>
                  Perfect for new traders embarking on their trading journey,
                  the Micro Account offers the opportunity to trade lower
                  volumes while gaining valuable market experience. Plus, enjoy
                  zero commissions on WLF Finance and get started with a minimum
                  deposit of just $50!
                </p>
                <Link to="/register">
                  <span className="me-2">Open Account</span>
                  <img src={image} alt="" />
                </Link>
              </div>
              <div className="trading-accounts-card-item">
                <h3>Standard</h3>
                <p>
                  Designed for traders ready to trade higher volumes and dive
                  deeper into the markets, the Standard Account allows you to
                  trade up to 50 lots. Enjoy commission-free WLF Finance and
                  start your journey with a minimum deposit of just $300!
                </p>
                <Link to="/register">
                  <span className="me-2">Open Account</span>
                  <img src={image} alt="" />
                </Link>
              </div>
              <div className="trading-accounts-card-item">
                <h3>Raw</h3>
                <p>
                  Perfect for scalpers, the Raw Account offers ultra-tight raw
                  spreads starting from 0.0, combined with no dealing desk STP
                  execution. Trade in a premium environment with commissions
                  starting from just $4 per lot on WLF Finance.
                </p>
                <Link to="/register">
                  <span className="me-2">Open Account</span>
                  <img src={image} alt="" />
                </Link>
              </div>
              <div className="trading-accounts-card-item">
                <h3>VIP</h3>
                <p>
                  The VIP Account is tailored for the most sophisticated traders
                  who value personalized support and premium services. Enjoy
                  one-on-one assistance from a dedicated account manager, and
                  our elite trading conditions with ultra-tight spreads and
                  ultra-low commissions.
                </p>
                <Link to="/register">
                  <span className="me-2">Open Account</span>
                  <img src={image} alt="" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TradingAccounts;
